var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "title-container" }, [
      _vm._v(_vm._s(_setup.text.title)),
    ]),
    _c("div", { staticClass: "text-container" }, [
      _c("img", {
        staticClass: "chat-icon",
        attrs: {
          src: require("@/assets/images/svg/icon-chat.svg"),
          alt: "chat-icon",
        },
      }),
      _c("p", [_vm._v(_vm._s(_setup.text.contact))]),
    ]),
    _c("button", { on: { click: _setup.launchChat } }, [
      _vm._v(_vm._s(_setup.text.start)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }